/* Lashthing: optie "Type Wimper" als fotokaarten (Natural/Shei vs Extra/Monica) en een
 * "Meest gekozen"-badge op de best verkochte "Lengte Wimper" (per type, uit verkoopdata).
 * Werkt bovenop de DOM van de Globo Color Swatch-app: Globo's radio-inputs en labels blijven
 * intact (variantwissel, prijs, voorraad), alleen de labels krijgen een close-up, een naam en een badge.
 * Zonder JS, zonder afbeelding-URL's of zonder config verandert er niets (Globo's tekstpills blijven staan).
 * A/B-test 2026-09-11: actief op de alternatieve productweergave ?view=fotokaarten (arm B); de standaardpagina (arm A) laadt dit script niet.
 * Extra op arm B: de URL houdt ?view= vast bij variantwissel, de kit-switcher (Globo product groups) linkt door mét ?view=,
 * en de winkelwagen krijgt eenmalig het attribuut _lt_ab zodat B-orders herkenbaar zijn in Shopify. */
(function () {
  'use strict';

  var TYPE_OPTION = 'type wimper';
  var LENGTH_OPTION = 'lengte wimper';
  var IMAGES = window.LT_TYPE_SWATCH_IMAGES || {};
  var CONFIG = window.LT_TYPE_SWATCH_CONFIG || {};
  var BADGE_TEXT = CONFIG.badge || 'Meest gekozen';
  var STYLES = [
    { match: /shei/i, key: 'shei' },
    { match: /monica/i, key: 'monica' }
  ];
  var CHECK_SVG = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 6.3l2.6 2.6L10 3.6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function parseValue(value) {
    // "Natural (shei)" -> { name: "Natural", sub: "Shei" }; "Natural (Shei)" idem (hoofdletterongevoelig)
    var m = /^\s*([^(]+?)\s*\(([^)]+)\)\s*$/.exec(value || '');
    if (!m) return { name: (value || '').trim(), sub: '' };
    var sub = m[2].trim();
    return { name: m[1].trim(), sub: sub.charAt(0).toUpperCase() + sub.slice(1).toLowerCase() };
  }

  function styleFor(value) {
    for (var i = 0; i < STYLES.length; i++) {
      if (STYLES[i].match.test(value || '')) return STYLES[i];
    }
    return null;
  }

  function norm(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, '');
  }

  function el(tag, className, html) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (html) node.innerHTML = html;
    return node;
  }

  function optionName(block) {
    var legend = block.querySelector('legend.name-option');
    if (!legend) return '';
    return (legend.getAttribute('data-name') || (legend.firstChild && legend.firstChild.textContent) || '').trim().toLowerCase();
  }

  function blocks() {
    return Array.prototype.slice.call(document.querySelectorAll('.globo-swatch-product-detail .swatch--gl'));
  }

  function findBlock(name) {
    var all = blocks();
    for (var i = 0; i < all.length; i++) {
      if (optionName(all[i]) === name) return all[i];
    }
    return null;
  }

  /* ---------- Type Wimper: fotokaarten ---------- */

  function enhanceTypeItem(li) {
    if (li.classList.contains('lt-type__item')) return false;
    var value = li.getAttribute('data-value') || '';
    var label = li.querySelector('label.swatch-anchor');
    var style = styleFor(value);
    if (!label || !style || !IMAGES[style.key]) return false;

    var parsed = parseValue(value);

    var media = el('span', 'lt-type__media');
    var img = document.createElement('img');
    img.src = IMAGES[style.key];
    img.alt = '';
    img.width = 720;
    img.height = 480;
    img.decoding = 'async';
    media.appendChild(img);
    media.appendChild(el('span', 'lt-type__check', CHECK_SVG));

    var body = el('span', 'lt-type__body');
    var name = el('span', 'lt-type__name');
    name.textContent = parsed.name;
    body.appendChild(name);
    if (parsed.sub) {
      var sub = el('span', 'lt-type__sub');
      sub.textContent = parsed.sub;
      body.appendChild(sub);
    }

    // Losse tekstknopen ("Natural (shei)") weg; Globo's .attr-title-hover blijft staan (wordt verborgen via CSS).
    Array.prototype.slice.call(label.childNodes).forEach(function (node) {
      if (node.nodeType === 3) label.removeChild(node);
    });
    label.appendChild(media);
    label.appendChild(body);
    label.classList.add('lt-type__card');
    li.classList.add('lt-type__item');
    return true;
  }

  function enhanceTypeBlock(block) {
    var changed = false;
    Array.prototype.forEach.call(block.querySelectorAll('li.select-option'), function (li) {
      if (enhanceTypeItem(li)) changed = true;
    });
    if (changed || block.querySelector('.lt-type__item')) block.classList.add('lt-type');
  }

  function currentStyleKey(typeBlock) {
    if (!typeBlock) return null;
    var checked = typeBlock.querySelector('input:checked');
    var style = styleFor(checked ? checked.value : '');
    return style ? style.key : null;
  }

  /* ---------- Lengte Wimper: "Meest gekozen"-badge ---------- */

  function popularLengthFor(styleKey) {
    var per = CONFIG.popular || {};
    return (styleKey && per[styleKey]) || CONFIG.popularDefault || '';
  }

  function applyLengthBadge(lengthBlock, typeBlock) {
    if (!lengthBlock) return;
    var popular = norm(popularLengthFor(currentStyleKey(typeBlock)));
    var items = Array.prototype.slice.call(lengthBlock.querySelectorAll('li.select-option'));
    var target = null;
    items.forEach(function (li) {
      if (!target && norm(li.getAttribute('data-value')) === popular) target = li;
    });
    var existing = Array.prototype.slice.call(lengthBlock.querySelectorAll('.lt-len__badge'));
    // idempotent: niets doen als de badge al precies op de juiste pill staat (voorkomt observer-lussen)
    if (existing.length === 1 && target && target.contains(existing[0])) {
      lengthBlock.classList.add('lt-len');
      return;
    }
    if (!target && existing.length === 0) return;
    existing.forEach(function (badge) { badge.parentNode.removeChild(badge); });
    items.forEach(function (li) { li.classList.remove('lt-len__item--popular'); });
    if (target) {
      var label = target.querySelector('label.swatch-anchor');
      if (!label) return;
      var badge = el('span', 'lt-len__badge');
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = BADGE_TEXT;
      var sr = el('span', 'visually-hidden');
      sr.textContent = ', ' + BADGE_TEXT.toLowerCase();
      badge.appendChild(sr);
      label.appendChild(badge);
      target.classList.add('lt-len__item--popular');
    }
    lengthBlock.classList.add('lt-len');
  }

  /* ---------- arm B: ?view= vasthouden, kit-switcher door-linken, cart-attribuut ---------- */

  var VIEW = CONFIG.view || '';

  function withView(href) {
    if (!VIEW || !href || /^(#|javascript:|mailto:|tel:)/i.test(href)) return href;
    try {
      var u = new URL(href, window.location.href);
      if (u.origin !== window.location.origin || u.pathname.indexOf('/products/') !== 0) return href;
      u.searchParams.set('view', VIEW);
      return u.pathname + u.search + u.hash;
    } catch (err) { return href; }
  }

  function keepView() {
    if (!VIEW) return;
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('view') === VIEW) return;
      u.searchParams.set('view', VIEW);
      window.history.replaceState(window.history.state, '', u.toString());
    } catch (err) { /* stil */ }
  }

  function linkGroups() {
    if (!VIEW) return;
    Array.prototype.forEach.call(document.querySelectorAll('.globo-product-groups-detail a[href]'), function (a) {
      var href = a.getAttribute('href');
      var next = withView(href);
      if (next !== href) a.setAttribute('href', next);
    });
  }

  function tagCart() {
    if (!CONFIG.ab) return;
    try {
      if (window.sessionStorage.getItem('lt_ab_tagged') === CONFIG.ab) return;
    } catch (err) { /* private mode: dan gewoon elke keer */ }
    try {
      var xhr = new XMLHttpRequest(); // bewust geen fetch: Kaching Cart patcht window.fetch
      xhr.open('POST', '/cart/update.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { window.sessionStorage.setItem('lt_ab_tagged', CONFIG.ab); } catch (err) { /* stil */ }
        }
      };
      xhr.send(JSON.stringify({ attributes: { _lt_ab: CONFIG.ab } }));
    } catch (err) { /* stil */ }
  }

  /* ---------- orchestratie ---------- */

  function scan() {
    var typeBlock = findBlock(TYPE_OPTION);
    if (typeBlock) enhanceTypeBlock(typeBlock);
    applyLengthBadge(findBlock(LENGTH_OPTION), typeBlock);
    linkGroups();
  }

  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      scan();
    });
  }

  function start() {
    scan();
    keepView();
    tagCart();
    // Globo rendert client-side en kan opnieuw renderen bij een variantwissel: blijven kijken.
    var root = document.querySelector('.product__info-container') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(scheduleScan).observe(root, { childList: true, subtree: true });
    } else {
      setInterval(scan, 1000);
    }
    // Type gewisseld: badge naar de best verkochte lengte van dat type.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name && /^globo-option-/.test(t.name)) {
        scheduleScan();
        // Dawn/Globo herschrijven de URL naar ?variant=… en laten ?view= vallen: terugzetten.
        window.setTimeout(keepView, 400);
        window.setTimeout(keepView, 1500);
      }
    }, true);
    // Kit-switcher: Globo navigeert via zijn eigen handler; zorg dat de klik mét ?view= doorgaat.
    document.addEventListener('click', function (e) {
      if (!VIEW) return;
      var a = e.target && e.target.closest ? e.target.closest('.globo-product-groups-detail a[href]') : null;
      if (!a) return;
      var href = withView(a.getAttribute('href'));
      if (href && href !== a.getAttribute('href')) a.setAttribute('href', href);
      if (href && /[?&]view=/.test(href)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = href;
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
